import type { CourseContent } from "@/services/vitrin-service";
import ContentView from "@/features/content-v2/components/content-view";
import LessonPlaylist from "@/features/content-v2/components/lesson-playlist";

type Props = {
  contents: CourseContent[];
  lessonTitle?: string;
  analyticsContext?: {
    miniappId?: string;
    courseId?: number;
    lessonId?: number;
  };
  hasNextPage?: boolean;
  isFetchingMore?: boolean;
  onLoadMore?: () => void;
};

export default function LessonContents({
  contents,
  lessonTitle,
  analyticsContext,
  hasNextPage,
  isFetchingMore,
  onLoadMore,
}: Props) {
  if (!contents.length) {
    return (
      <div className="py-6 text-center text-sm text-default-400">
        محتوایی یافت نشد.
      </div>
    );
  }

  // A single piece of content needs no playlist chrome — show it directly. With
  // nothing to sit beside it, it takes the middle of the desktop rail rather
  // than stretching across the whole of it.
  if (contents.length === 1) {
    return (
      <div dir="rtl" className="px-4 pb-8 lg:mx-auto lg:max-w-4xl lg:px-0">
        <ContentView
          content={contents[0]}
          lessonTitle={lessonTitle}
          analyticsContext={analyticsContext}
        />
      </div>
    );
  }

  return (
    <LessonPlaylist
      contents={contents}
      lessonTitle={lessonTitle}
      analyticsContext={analyticsContext}
      hasNextPage={hasNextPage}
      isFetchingMore={isFetchingMore}
      onLoadMore={onLoadMore}
    />
  );
}
